import { render, staticRenderFns } from "./UserConfigsForm.vue?vue&type=template&id=15ccd460"
import script from "./UserConfigsForm.vue?vue&type=script&lang=js"
export * from "./UserConfigsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports